module.exports = __webpack_public_path__ + "img/shape_hearth--blue.931c53c.png";